import { render, staticRenderFns } from "./AccountProfileOrders.vue?vue&type=template&id=14577974&"
import script from "./AccountProfileOrders.vue?vue&type=script&lang=js&"
export * from "./AccountProfileOrders.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports